import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent = icon;

  if (!IconComponent && name) {
    try {
      // Handle both "Code" and "FiCode" formats
      const iconKey = name.startsWith('Fi') ? name : `Fi${name}`;
      IconComponent = FiIcons[iconKey];
    } catch (e) {
      console.error(`Error loading icon: ${name}`, e);
      IconComponent = null;
    }
  }

  // Final fallback to Alert triangle if nothing found
  if (!IconComponent) {
    return <FiAlertTriangle {...props} />;
  }

  return React.createElement(IconComponent, props);
};

export default SafeIcon;